import { render, staticRenderFns } from "./UserReviews.vue?vue&type=template&id=126d8382"
import script from "./UserReviews.vue?vue&type=script&lang=js"
export * from "./UserReviews.vue?vue&type=script&lang=js"
import style0 from "./UserReviews.vue?vue&type=style&index=0&id=126d8382&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports